<wlm-popup-wrapper
  [titleKey]="T_SCOPE + '.title'"
  [showCloseButton]="true"
  popupContainerClass="custom-popup-inherit-height"
  contentContainerClass="custom-popup-hide-overflow"
  (popupClose)="cancel($event)"
>
  <ng-container popup-content>
    <ct-dashboard-child-config
      [cartAndSettings]="cartAndSettings"
      [newItems]="newItems"
      [newVisibleItems]="newVisibleItems"
      (isAllValid)="onValidChange($event)"
    ></ct-dashboard-child-config>
  </ng-container>
  <ng-container popup-actions>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!isValid || isLoading">
      {{ 'common.save' | translate }}
    </button>
  </ng-container>
</wlm-popup-wrapper>
